module.exports = __webpack_public_path__ + "static/media/4.84fafbc2.png";